import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function AboutUs() {
  return (
    <div className="container py-5">
      {/* Header */}
      <div className="text-center mb-5">
        <h1 className="display-4">Welcome to Tee Blanka®</h1>
        <p className="lead">Your T-Shirt Destination!</p>
      </div>

      {/* Founder Info */}
      <div className="row mb-5">
        <div className="col-md-12">
          <h3>About Us</h3>
          <p>
            <strong>Tee Blanka®</strong> is a proprietorship firm founded and led by <strong>Mr. Sacchin S. Jain – Kasliwal</strong>,
            a seasoned expert with over 25 years in the printing and garment industry.
            Under the technical and creative guidance of <strong>Jain Screen®</strong> and supported by wholesale partner <strong>Magcool LLP</strong>,
            we deliver premium-quality apparel tailored for individuals and B2B clients.
          </p>
        </div>
      </div>

      {/* Vision */}
      <div className="row mb-5">
        <div className="col-md-12 bg-light p-4 rounded">
          <h4>Our Vision</h4>
          <p>
            To become India’s most trusted brand for customized t-shirts and sublimation apparel – blending fashion with functionality.
          </p>
        </div>
      </div>

      {/* What We Offer */}
      <div className="row mb-5">
        <div className="col-md-12">
          <h4>What We Offer</h4>
          <p>Through our signature brand <strong>Tri9tee®</strong>, we design and manufacture:</p>
          <ul>
            <li>🏏 Sports Jerseys & League T-Shirts</li>
            <li>🙏 Festival & Religious Themed T-Shirts</li>
            <li>🧑‍🎓 College, Group & Event Tees</li>
            <li>🧢 Custom Caps, Lanyards & Accessories</li>
          </ul>
          <p>
            Every product is made using high-grade 100% polyester fabric with advanced sublimation printing for lasting color, comfort, and style.
          </p>
        </div>
      </div>

      {/* B2B Solutions */}
      <div className="row mb-5">
        <div className="col-md-12 bg-light p-4 rounded">
          <h4>B2B Solutions – Built for Business</h4>
          <p>We serve resellers, corporates, event organizers, institutions, and marketing agencies with scalable solutions:</p>
          <ul>
            <li>🔹 Custom branding and logo placement</li>
            <li>🔹 Bulk order support with fast turnaround</li>
            <li>🔹 Distributor and dealer partnerships across India</li>
            <li>🔹 White-label manufacturing for private brands</li>
            <li>🔹 Dedicated B2B pricing and logistic support</li>
          </ul>
          <p>
            Whether you're launching a campaign, running a sports league, or building your own apparel brand —
            <strong> Tee Blanka® </strong> is your trusted back-end partner.
          </p>
        </div>
      </div>

      {/* Legacy & Support */}
      <div className="row mb-5">
        <div className="col-md-12">
          <h4>Backed by Legacy & Wholesale Strength</h4>
          <ul>
            <li>✅ Creative Direction by: <strong>Jain Screen®</strong> – A pioneer in printing & customization</li>
            <li>✅ Wholesale Infrastructure by: <strong>Magcool LLP</strong> – Experienced wholesale apparel supply experts</li>
          </ul>
          <p><em>We don’t just print – we help build brands.</em></p>
        </div>
      </div>

      {/* Contact & CTA */}
      <div className="row text-center">
        <div className="col-md-12">
          <h5>📞 Let’s Collaborate</h5>
          <p>
            🌐 <a href="https://www.teeblanka.com" target="_blank" rel="noopener noreferrer">www.teeblanka.com</a><br />
            📩 <a href="mailto:support@teeblanka.com">support@teeblanka.com</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
